import { FC, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Message from "./Message";
import TypingIndicator from "./TypingIndicator";
import { saveAs } from "file-saver";
import { PreviewerModal } from "../../../components/modals/previewer-modal";
import { IStatus } from "../../../app/chatAgent/types";
import * as chatActions from "../../../app/chatAgent/chatAgentSlice";
import generateUuid from "../../../utils/generateUuid";

interface IProps {
    chats?: Array<{
        senderId: string;
        senderName: string;
        message: string;
        messageTime: Date;
        minMessageTime: boolean;
        messageType: string;
        roomOwner: boolean;
        isSent: boolean;
        handledByAgent?: string;
        messageFiles: string[];
        duration?: number;
    }>;
}

const MessageBody: FC<IProps> = ({ chats }) => {

    const { activeRoom, status: chatAgentCallback } = useAppSelector((state) => state.chatagent);
    const { user } = useAppSelector((state) => state.auth);
    const [isTyping, setIsTyping] = useState(false);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const attachmentFile = "";
    const attachmentType = "";
    const viewerBody = <></>;
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (chatAgentCallback.status == "TYPING" && chatAgentCallback.userName != user?.username) {
            setIsTyping(true);
            const timeout = setTimeout(() => {
                setIsTyping(false);
                dispatch(chatActions.chatAgentCallBack({} as IStatus));
            }, 500);
            return () => clearTimeout(timeout);
        } else if (chatAgentCallback.status != "TYPING"
            && activeRoom.sessionId == chatAgentCallback.sessionId) {
            setIsTyping(false);
        }

    }, [activeRoom, chatAgentCallback]);
    const closeBtnModalHandler = () => {
        setIsViewerOpen(false);
    }
    const downloadBtnHandler = () => {
        saveAs(attachmentFile, attachmentFile.split('/').pop());
    }
    return (
        <>
            <div className="message-body">
                <div className="media-list" >
                    {chats?.map((chat) => {
                        return (<Message
                            key={generateUuid()}
                            text={chat.message}
                            variant={chat.senderName === user?.username ? "mine" : "other"}
                            time={chat.messageTime}
                            minTime={chat.minMessageTime}
                            senderId={chat.senderId}
                            isSent={chat.isSent}
                            handledByAgent={chat.handledByAgent}
                        />)
                    }
                    )}
                  
                </div>
            </div>
            <div className="pb-7">
                <TypingIndicator isTyping={isTyping} />
            </div>
            <PreviewerModal
                visible={isViewerOpen}
                onClose={closeBtnModalHandler}
                onDownload={downloadBtnHandler}
                viewerBody={viewerBody}
                attachmentType={attachmentType} />
        </>
    );
};

export default MessageBody;
